import React, { useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
import PropTypes from 'prop-types'
import * as validators from '../../utils/validators'

import {
  formContainer,
  titleContainer,
  mainTitle,
  buttonContainer,
  passwordInput
} from './styles/LoginForm.style'

import EyeIcon from './EyeIcon'
import EyeClosedIcon from './EyeClosedIcon'
import { Button } from '../shared/styles/Button.style'
import Input from '../shared/Input'

const LoginForm = ({
  handleSubmit,
  onSubmit,
  isSubmitting,
  translation,
  lang
}) => {
  const required = lang === 'pt-BR' ? validators.requiredPT : validators.requiredES
  const emailOrFractalId = lang === 'pt-BR' ? validators.emailOrFractalIdPT : validators.emailOrFractalIdES
  const [showPassword, setShowPassword] = useState(false)
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }
  const passwordInputType = showPassword ? 'text' : 'password'
  return (
    <form className={formContainer} onSubmit={handleSubmit(onSubmit)}>
      <header className={titleContainer}>
        <h1 className={mainTitle}>Login</h1>
      </header>

      <div className={passwordInput}>
        <Field
          name='login'
          placeholder={translation('login')['fractalIdPlaceholder']}
          type='text'
          block
          validate={[required, emailOrFractalId]}
          component={Input}
        />
        <div style={{ position: 'relative' }}>
          <Field
            name='password'
            placeholder={translation('login')['passwordPlaceholder']}
            type={passwordInputType}
            block
            validate={[required]}
            component={Input}
          />
          {showPassword && <div onClick={togglePasswordVisibility} className='passwordBtn'><EyeIcon /></div>}
          {!showPassword && <div onClick={togglePasswordVisibility} className='passwordBtn'><EyeClosedIcon /></div>}
        </div>
      </div>
      <div className={buttonContainer}>
        <Button
          type='submit'
          disabled={isSubmitting}
        >
          {translation('login')['loginButton']}
        </Button>
      </div>
    </form>
  )
}

LoginForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  translation: PropTypes.func.isRequired,
  lang: PropTypes.string
}

const mapStateToProps = ({ auth }) => ({
  isSubmitting: auth.isFetching
})

const mappedConnect = connect(mapStateToProps)
const mappedReduxForm = reduxForm({
  form: 'login'
})

export default mappedConnect(mappedReduxForm(LoginForm))
